import clsx from 'clsx';
import { Icon, IconButton } from 'copilot-design-system';
import { MouseEventHandler } from 'react';

const actionButtonStyles =
  'p-[5px] rounded-md bg-transparent border-none text-gray-small';

export const FileUploadButton = () => (
  <div
    className={clsx(
      actionButtonStyles,
      'cursor-pointer flex items-center justify-center',
    )}
  >
    <Icon icon="Attachment" className="w-4 h-4 text-gray-small" />
  </div>
);

export const AtMentionButton = ({
  onClick,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
}) => (
  <IconButton
    className={actionButtonStyles}
    icon="At"
    variant="minimal"
    onClick={onClick}
    label="Mention user"
  />
);
